import { AddIcon } from "@chakra-ui/icons";
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Table,
  Tbody,
  Td,
  Tfoot,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {
  getAddQuestionData,
  setContent,
  setQuestions,
} from "redux/slices/AddQuestionSlice";
import {
  getAddTestData,
  setDescription,
  setTitle,
} from "redux/slices/AddTestSlice";
import AddQuestion from "./AddQuestion";

interface AddTestProps {
  submitHandler: (e: React.FormEvent) => void;
  testId: number;
  setTestId: React.Dispatch<React.SetStateAction<number>>;
}
const AddTest: React.FC<AddTestProps> = ({
  submitHandler,
  testId,
  setTestId,
}: AddTestProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useAppDispatch();
  const { title, description } = useAppSelector(getAddTestData);
  const { content } = useAppSelector(getAddQuestionData);
  const questions = useAppSelector(getAddQuestionData).questions;

  const [id, setId] = useState(0);
  const addQuestionSubmitHandler = (e: React.FormEvent) => {
    e.preventDefault();
    console.log({});
    dispatch(
      setQuestions([
        ...questions,
        {
          id: id,
          addedOn: new Date(),
          content,
          questionTypeId: 1,
          lastModifiedOn: new Date(),
          responseTimeout: 60,
          testId: testId,
        },
      ])
    );
    setId(id + 1);
    //dispatch(setAnswers([]))
    dispatch(setContent(""));
    console.log(questions);
  };
  return (
    <>
      <Button leftIcon={<AddIcon />} colorScheme={"brand"} onClick={onOpen}>
        Ajouter
      </Button>

      <Modal
        closeOnOverlayClick={false}
        size={"5xl"}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <form action="" onSubmit={submitHandler}>
          <ModalContent>
            <ModalHeader>Ajouter test</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <FormControl id="email">
                <FormLabel>Désignation de test</FormLabel>
                <Input
                  value={title}
                  onChange={(e) => dispatch(setTitle(e.target.value))}
                  borderRadius={"full"}
                  type="text"
                />
              </FormControl>
              <FormControl id="email">
                <FormLabel>Description</FormLabel>
                <Input
                  value={description}
                  onChange={(e) => dispatch(setDescription(e.target.value))}
                  borderRadius={"full"}
                  type="text"
                />
              </FormControl>

              <Stack my={5} direction="row" spacing={"auto"}>
                <Table variant="striped" colorScheme="brand">
                  <Thead>
                    <Tr>
                      <Th>Contenu</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {questions &&
                      questions.map((item) => (
                        <Tr>
                          <Td>{item.content}</Td>
                        </Tr>
                      ))}
                  </Tbody>
                  <Tfoot>
                    <Tr>
                      <Th>Contenu</Th>
                    </Tr>
                  </Tfoot>
                </Table>
                <AddQuestion
                  id={id}
                  setId={setId}
                  submitHandler={addQuestionSubmitHandler}
                />
              </Stack>
            </ModalBody>

            <ModalFooter>
              <Button
                type="button"
                onClick={(e) => {
                  submitHandler(e);
                  onClose();
                }}
                colorScheme="brand"
                mr={3}
              >
                Enregistrer
              </Button>
              <Button onClick={onClose}>Annuler</Button>
            </ModalFooter>
          </ModalContent>
        </form>
      </Modal>
    </>
  );
};

export default AddTest;
